import { type FC } from 'react';

import { CookiesText, LEGAL_DOCS } from '@entities/legal';
import { LegalDocument } from '@shared/ui/LegalDocument';

const CookiesPage: FC = () => (
  <LegalDocument title={LEGAL_DOCS.cookies.title}>
    <CookiesText />
  </LegalDocument>
);

export default CookiesPage;
